export default __webpack_public_path__ + "static/media/GFigurado.9b8b2b6b.png";